<!--
 * @Author: your name
 * @Date: 2021-03-02 19:08:19
 * @LastEditTime: 2022-04-23 11:56:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \raacfold\src\components\units\Global.vue
-->
<script>
    const protocol = "http";
    const ip = "183.175.59.3";
    const port = "8002";
    const website = `${protocol}://${ip}:${port}`;
    const jbrowser = `${protocol}://${ip}:89`;
    const kegg_websit = `${protocol}://${ip}:2333`;
    const localsite = "http://192.168.1.128:8080";
    // const source = "api/source/pdb";
    const source_cif = "api/source/cif";
    const source = "source/pdb";

    // const protocol = "http";
    // const ip = "183.175.59.23";
    // const port = "8005";
    // const website = `${protocol}://${ip}:${port}`;
    // const jbrowser = `${protocol}://${ip}:89`;
    // const kegg_websit = `${protocol}://${ip}:2333`;
    // const localsite = "http://192.168.1.128:8080";
    // const source = "api/source/pdb";

    export default
    {
        website,
        kegg_websit,
        localsite,
        jbrowser,
        source,
        source_cif
    }
</script>
